import React, { memo } from 'react';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import ChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';
import { Pressable, xcss } from '@atlaskit/primitives';
import { flagTextColorToken } from '../theme';
var buttonStyles = xcss({
  display: 'flex',
  width: '24px',
  height: '24px',
  padding: 'space.0',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  background: 'none',
  borderStyle: 'none',
  cursor: 'pointer',
  whiteSpace: 'nowrap'
});
var DismissButtonComponent = function DismissButtonComponent(_ref) {
  var appearance = _ref.appearance,
    onClick = _ref.onClick,
    isBold = _ref.isBold,
    isExpanded = _ref.isExpanded,
    testId = _ref.testId;
  var ButtonIcon = CrossIcon;
  var buttonLabel = 'Dismiss';
  var size = 'small';
  var buttonTestId = testId && "".concat(testId, "-dismiss");
  if (isBold) {
    ButtonIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;
    buttonLabel = isExpanded ? 'Collapse' : 'Expand';
    size = 'medium';
    buttonTestId = testId && "".concat(testId, "-toggle");
  }
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: buttonStyles,
    onClick: onClick,
    "aria-expanded": isBold ? isExpanded : undefined,
    testId: buttonTestId,
    "aria-label": buttonLabel
  }, /*#__PURE__*/React.createElement(ButtonIcon, {
    label: "",
    size: size,
    primaryColor: flagTextColorToken[appearance]
  }));
};
var DismissButton = /*#__PURE__*/memo(DismissButtonComponent);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default DismissButton;